module.exports = __webpack_public_path__ + "img/google_sync_tooltip_img.dc5e1fa6.png";